import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../config/endpoints";
import axiosConfig from "../../../utils/axiosConfig";

const initialState = {
  loading: false,
  customersStatus: null,
  searchWord: "",
  error: "",
};

export const getCustomersStatus = createAsyncThunk(
  "customersStatus/fetch",
  async (args, { getState }) => {
    return axiosConfig(
      `${endpoints.precustomerWithStatus}/fetch-${args?.status}-customers?repId=${args?.repId}`
    );
  }
);

const customersStatusSlice = createSlice({
  name: "customersStatus",
  initialState,
  reducers: {
    updateSearchTerm: (state, action) => {
      state.searchWord = action.payload;
      state.params.SearchText = action.payload.length > 3 ? action.payload : "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomersStatus.pending, (state) => {
      state.loading = true;
      state.customersStatus = null;
    });
    builder.addCase(getCustomersStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.customersStatus = action.payload;
      state.error = "";

      console.log(action?.payload);
    });
    builder.addCase(getCustomersStatus.rejected, (state, action) => {
      state.loading = false;
      state.customersStatus = {};
      state.error = "Error, Failed to load";
    });
  },
});

export default customersStatusSlice.reducer;
export const {
  updateSearchTerm,
} = customersStatusSlice.actions;
